import React, {useState, useEffect} from "react";
import {Checkbox, Input, List, Pagination, Space, Spin} from "antd";
import {CaretDownFilled, SearchOutlined, LoadingOutlined} from "@ant-design/icons";
import FilterBullet from "../../../helpers/components/filter_bullet";
import CustomerService from "../../../services/ewallet_integration/customer.service";

const TransactionTypeFilter = ({
                                   searchText,
                                   setSearchText,
                                   filter = {},
                                   onChange: onCheckChange,
                               }) => {
    const [localState, setLocalState] = useState({
        loading: false,
        transaction_type: [],
    });

    // Main data fetching function
    const loadTransactionType = async () => {
        setLocalState(prev => ({...prev, loading: true}));

        const result = await CustomerService.transaction_type({
            search: searchText,
        });

        const transaction_type = result?.data?.transaction_type || [];

        setLocalState(prev => ({
            ...prev,
            loading: false,
            transaction_type,
        }));
    };

    // Load activities on first render or when search changes
    useEffect(() => {
        loadTransactionType(); // reset to page 1 on search change
    }, [searchText]);

    return (
        <FilterBullet
            popover={
                <>
                    <div>
                        <Input prefix={<SearchOutlined style={{color: 'var(--secondary-text-color)'}}/>}
                               placeholder='Search Transaction Type'/>
                    </div>

                    <Checkbox.Group
                        // disabled={ticketRedux?.list_loading}
                        value={filter?.transaction_types}
                        onChange={(checkedValues) => onCheckChange('transaction_types', checkedValues)}
                    >
                        <List
                            style={{width: 280,}}
                            dataSource={localState?.transaction_type}
                            renderItem={(item, index) => {
                                const {transaction_type_id, name,} = item ?? {};
                                return (
                                    <List.Item style={{width: '100%'}} key={index}>
                                        <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                            <div>
                                                <span>{name}</span>
                                            </div>
                                            <div style={{marginLeft: 'auto'}}>
                                                <Checkbox
                                                    value={transaction_type_id}
                                                />
                                            </div>
                                        </div>
                                    </List.Item>
                                )
                            }}
                        />
                    </Checkbox.Group>
                </>
            }
        >
            <div>
                <Space>
                    <div>
                      <span>
                          Transaction Types
                          {filter?.transaction_types?.length > 0 && localState?.transaction_type?.length > 0
                              ? `: ${localState.transaction_type
                                  .filter(type => filter.transaction_types.includes(type.transaction_type_id))
                                  .map(type => type.name)
                                  .join(', ')}`
                              : ''}
                        </span>
                    </div>
                    <div>
                        <CaretDownFilled style={{color: '#a0aec0'}}/>
                    </div>
                </Space>

            </div>
        </FilterBullet>
    );
};

export default TransactionTypeFilter;
